import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompanyLegalityStatus = createAsyncThunk('/dashboard_detail_company_legality_status/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/detailCompanyLegalityStatusDash/${id}`, {})
    return response.data;
})


export const dashboardDetailCompanyLegalityStatusSlice = createSlice({
    name: 'dashboard_detail_company_legality_status',
    initialState: {
        isLoading: false,
        dashboard_detail_company_legality_status: []
    },

    /*extraReducers: {
        [getDetailCompanyLegalityStatus.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompanyLegalityStatus.fulfilled]: (state, action) => {
            state.dashboard_detail_company_legality_status = action.payload.data
            state.isLoading = false
        },
        [getDetailCompanyLegalityStatus.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompanyLegalityStatus.pending, (state) => {
                state.isLoading = true;             
            })          
            .addCase(getDetailCompanyLegalityStatus.fulfilled, (state, action) => {                 
                state.dashboard_detail_company_legality_status = action.payload.data;
                state.isLoading = false;             
            })          
            .addCase(getDetailCompanyLegalityStatus.rejected, (state) => {                 
                state.isLoading = false;             
            });
    }
})

export default dashboardDetailCompanyLegalityStatusSlice.reducer